import { AppErrorBoundary } from 'components/featured/AppErrorBoundary/AppErrorBoundary';
import Layout from 'core/components/Layout/Layout';
import LoginPage from 'module/auth/pages/LoginPage';
import { PrivateRoute } from 'module/auth/PrivateRoutes';
import { ROUTES } from 'module/navigation/enums/routes.enums';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

// import SituationRoom from 'module/situationRoom/pages/SituationRoom';
// import GuestProtect from 'module/guestprotect/page/GuestProtect';
import GuestCheck from 'module/guestconnect/page/GuestCheck';
import OAuthCallback from 'module/settings/OAuthCallback';

function App(): JSX.Element {
	return (
		<>
			<Router>
				<AppErrorBoundary>
					<Switch>
						<Route exact path={ROUTES.LOGIN} component={LoginPage} />
						{/* <Route
                        exact
                        path={ROUTES.GUESTPROTECT}
                        component={GuestProtect}
                    /> */}
						<Route exact path={ROUTES.GUESTCONNECTSTAFF} component={GuestCheck} />
						<Route exact path="/oauth/callback" component={OAuthCallback} />
						{/* /oath/callback — backend redirect alias (missing 'u' in oauth) */}
						<Route exact path="/oath/callback" component={OAuthCallback} />
						{/* Microsoft OneDrive OAuth redirect from backend */}
						<Route exact path="/oauth/ms-callback" component={OAuthCallback} />
						<PrivateRoute path="" component={Layout} />
					</Switch>
				</AppErrorBoundary>
			</Router>
		</>
	);
}

export default App;
